function isEmpty(value, text = "") {
 let message = "";
 if (typeof value === "string") {
  if (!value.trim()) {
   message = "Ingrese " + text;
   return message;
  }
 } else if (typeof value === "number") {
  if (!toString(value)) {
   message = "Ingrese " + text;
   return message;
  }
 }
 return message;
}

function minLength(value, length) {
 let message = "";

 if (value.length < length) {
  message = "Ingresa  como minimo caracteres " + length;
 }
 return message;
}

function minDivisionSelected(
 value = [],
 _minCheckBoxSelected,
 text = "",
 isOnlyPrice = false
) {
 let message = "";
 if (value.length == 0) {
  message = "Debe seleccionar mínimo " + _minCheckBoxSelected + text;
  return message;
 } else if (isOnlyPrice) {
  if (value[1][0].length == 0) {
   message = "Debe seleccionar mínimo " + _minCheckBoxSelected + text;
   return message;
  }
 }
 return message;
}

function minPrice(value, minValue, text = "") {
 let message = "";
 if (Number(value) == 0) {
  message = "El precio" + text + " debe ser mayor a " + minValue;
  return message;
 }
 return message;
}

function maxPrice(value, maxValue, text) {
 let message = "";
 if (Number(value) > maxValue) {
  message = "El precio" + text + " no debe ser mayor a " + maxValue;
  return message;
 }
 return message;
}

export { isEmpty, minPrice, maxPrice, minDivisionSelected, minLength };
